import React from 'react';

import styled from 'styled-components';
import LandingVideo2 from '../img/landingvideo2-compressed-2.mp4';
import { FaChevronRight } from "react-icons/fa";

const LandingContainer = styled.div`
  position: relative;
  color: white;
  overflow: hidden;
  display: flex;
  justify-content: space-between;
  align-items: center;
  min-height: 100vh;
  padding: 0 10%;
  
  @media (max-width: 1024px) {
    flex-direction: column;
    text-align: left;
    justify-content: center;
    min-height: 80vh;
    padding: 10rem 5%;
  }
`;

const BackgroundVideo = styled.video`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  z-index: -1;
`;

const VideoOverlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.3);
  z-index: -1;
`;

const LandingImage = styled.div`
  flex: 1;
  display: flex;
  justify-content: flex-start;
  max-width: 55%;
  opacity: 1;

  @media (max-width: 1024px) {
    max-width: 100%;
    justify-content: center;
  }
`;

const LandingContent = styled.div`
  flex: 1;
  max-width: 550px;
  text-align: left;

  @media (max-width: 1024px) {
    max-width: 100%;
    text-align: left;
    margin-top: 2rem;
  }
`;



const Subtitle = styled.p`
  font-size: 0.65rem;
  font-weight: 600;
  opacity: 0.8; /* Increased visibility */
  text-transform: uppercase;
  letter-spacing: 2px;
  color: #fffff;
  margin-bottom: 10px;
  text-shadow: #4A90E2 1px 1px 6px; /* Soft blue glow effect */

  padding-bottom: 10px;
  display: inline-block; /* Prevents collapsing issues */
`;


const Title = styled.h1`
  font-size: 40px;
  font-weight: 500;
  line-height: 43px; /* Improved readability */
  letter-spacing: -0.01em; /* Slight spacing for clarity */
  margin-bottom: 16px;
  padding-bottom: 10px;

  @media (max-width: 1024px) {
    font-size: 28px;
    line-height: 38px;
  }

  @media (max-width: 768px) {
    font-size: 26px;
    line-height: 34px;
  }
`;


const Description = styled.p`
  font-size: 16px;
  font-weight: 500;
  line-height: 21px; /* Improved readability */
  letter-spacing: -0.01em; /* Slight spacing for clarity */
  font-weight: 300;
  opacity: 0.9;
    text-shadow: rgb(0, 0, 0) 1px 1px 6px; /* Soft glow effect */
  padding-bottom: 10px;

  @media (max-width: 1024px) {
    font-size: 1rem;
    line-height: 1.4;
  }

  @media (max-width: 768px) {
    font-size: 0.95rem;
  }
`;

const LandingButtons = styled.div`
  margin-top: 2rem;
  display: flex;
  gap: 1rem;

  @media (max-width: 1024px) {
    flex-direction: column;
    align-items: center;
  }
`;

const Button = styled.a`
  background: #38a6fb;
  color: white;
  font-size: 0.8rem;
  font-weight: 500;
  text-transform: uppercase;
  padding: 20px;
  border-radius: 8px;
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  text-decoration: none;
  transition: 0.3s;

  &:hover {
    background: #357ABD;
  }

  @media (max-width: 768px) {
    padding: 18px;
    font-size: 0.85rem;
  }
`;

const HomePageHeroOwnTomorrow = ({
  isConsideredMobile,
  signedIn,
}) => {
  const scrollToEarnPro = (event) => {
    event.preventDefault(); // Prevent default anchor behavior

    const servicesSection = document.getElementById("earn-pro");
    if (servicesSection) {
      servicesSection.scrollIntoView({ behavior: "smooth" });
    }
  };
  return (
    <>
      <LandingContainer>
        {/* Fullscreen Video Background */}
        <BackgroundVideo autoPlay loop muted playsInline>
          <source src={LandingVideo2} type="video/mp4" />
        </BackgroundVideo>

        {/* Black Overlay */}
        <VideoOverlay />

        {/* Left Side: Empty Div (keeps layout) */}
        <LandingImage />

        {/* Right Side: Content */}
        <LandingContent>
          <Subtitle>OWN YOUR TOMORROW</Subtitle>
          <Title>
            AI assisted title and escrow onchain for real estate.
          </Title>
          <Description>
            Propy AI reduces human work by 40%. Deeds are recorded 
            onchain to avoid fraud. Get full transparency on your home 
            purchase 24/7.
          </Description>
          <LandingButtons>
            <Button onClick={scrollToEarnPro}>
              JOIN THE MOVEMENT
              <FaChevronRight />
            </Button>
          </LandingButtons>
        </LandingContent>
      </LandingContainer>
    </>
  );
};

export default HomePageHeroOwnTomorrow;